import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section content-container" }
const _hoisted_2 = { class: "container is-fluid" }
const _hoisted_3 = { class: "island" }
const _hoisted_4 = { class: "level" }
const _hoisted_5 = { class: "level-right" }
const _hoisted_6 = { class: "level-item" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "is-archived" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]

import { ContactAttributeViewModel } from '@/messaging/models/contactAttributeViewModel';
import DataTable from '@/shared/components/dataTable/DataTable.vue';
import FriendlyString from '@/shared/components/FriendlyString.vue';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import CreateAttribute from '@/features/settings/components/CreateAttribute.vue';
import { ContactAttributeType } from '@/messaging/models/contactAttributeType';
import UpdateAttribute from '@/features/settings/components/UpdateAttribute.vue';
import DataTableColumn from '@/shared/components/dataTable/dataTableColumn';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import HtmlFormatter from '@/shared/services/htmlFormatter';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import { ARCHIVE_CONTACT_ATTRIBUTE } from '@/store/attributes/actionTypes';
import Toast from '@/shared/services/toast';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactAttributes',
  setup(__props) {

const store = useStore();
const updateAttribute = (attributeId: string) => store.dispatch(ARCHIVE_CONTACT_ATTRIBUTE, attributeId);
const allContactAttributes = computed(() => store.getters.allContactAttributes);

const showCreateAttributeModal = ref(false);
const showUpdateAttributeModal = ref(false);
const showArchiveAttributeModal = ref(false);
const selectedAttribute = ref<ContactAttributeViewModel>(<ContactAttributeViewModel>{});

function openCreateAttributeModal() {
  showCreateAttributeModal.value = true;
}

function openEditAttribute(attribute: ContactAttributeViewModel) {
  selectedAttribute.value = attribute;
  showUpdateAttributeModal.value = true;
}

function closeAttributeModal() {
  showCreateAttributeModal.value = false;
  showUpdateAttributeModal.value = false;
}

function getTypeDisplay(typeValue: string) {
  return Object.keys(ContactAttributeType).filter((x) => (ContactAttributeType as any)[x] === typeValue)[0];
}

function showArchiveModal(attribute: ContactAttributeViewModel) {
  selectedAttribute.value = attribute;
  showArchiveAttributeModal.value = true;
}

async function archiveAttribute() {
  showArchiveAttributeModal.value = false;
  try {
    await updateAttribute(selectedAttribute.value.id);
    Toast.showSuccess(`Successfully archived attribute: ${selectedAttribute.value.name}`);
  } catch (err) {
    Toast.showError(err.message);
  }
}

function getArchiveConfirmationMessage() {
  return `Are you sure you want to archive attribute <b>${HtmlFormatter.escapeHtmlCharacters(selectedAttribute.value.name)}</b>?`;
}

function getColumns(): DataTableColumn[] {
  return [
    {
      display: 'Name',
      name: 'name',
      clickable: (row: ContactAttributeViewModel) => !row.system && !row.archived,
    },
    {
      display: 'Type',
      name: 'type',
    },
    {
      display: 'Description',
      name: 'description',
      wrappable: true,
    },
  ];
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "level-left" }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _createVNode(_component_n_button, {
                id: "create-contact-attribute-btn",
                variant: "primary",
                onClick: openCreateAttributeModal
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("span", null, "Create Attribute", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(DataTable, {
          data: allContactAttributes.value,
          columns: getColumns(),
          onCellClicked: openEditAttribute,
          class: "contact-attributes-table"
        }, {
          type: _withCtx(({ row }) => [
            _createVNode(FriendlyString, {
              value: getTypeDisplay(row.type)
            }, null, 8, ["value"])
          ]),
          name: _withCtx(({ row }) => [
            (!row.system && !row.archived)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "clickable-cell",
                  onClick: ($event: any) => (openEditAttribute(row))
                }, _toDisplayString(row.name), 9, _hoisted_7))
              : _createCommentVNode("", true),
            (!row.system && row.archived)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(row.name), 1),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "tag is-warning" }, "Archived", -1))
                ]))
              : _createCommentVNode("", true),
            (row.system)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row.name), 1))
              : _createCommentVNode("", true)
          ]),
          actions: _withCtx(({ row }) => [
            (!row.system && !row.archived)
              ? (_openBlock(), _createBlock(DropDownMenu, {
                  key: 0,
                  "go-left": true,
                  dropDownIcon: "dots"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (showArchiveModal(row)),
                      class: "dropdown-item"
                    }, [
                      _createVNode(DeleteIcon),
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "action-label" }, "Archive", -1))
                    ], 8, _hoisted_11)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data", "columns"])
      ])
    ]),
    (showCreateAttributeModal.value)
      ? (_openBlock(), _createBlock(CreateAttribute, {
          key: 0,
          onCancel: closeAttributeModal,
          onCreate: closeAttributeModal
        }))
      : _createCommentVNode("", true),
    (showUpdateAttributeModal.value)
      ? (_openBlock(), _createBlock(UpdateAttribute, {
          key: 1,
          attribute: selectedAttribute.value,
          onCancel: closeAttributeModal,
          onUpdate: closeAttributeModal
        }, null, 8, ["attribute"]))
      : _createCommentVNode("", true),
    (showArchiveAttributeModal.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 2,
          id: "archive-attribute-modal",
          confirmationTitle: "Archive Contact Attribute",
          confirmationMessage: getArchiveConfirmationMessage(),
          onConfirm: archiveAttribute,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (showArchiveAttributeModal.value = false))
        }, null, 8, ["confirmationMessage"]))
      : _createCommentVNode("", true)
  ]))
}
}

})